import { render, staticRenderFns } from "./CreatePersonalLink.vue?vue&type=template&id=6cd6872a&scoped=true"
import script from "./CreatePersonalLink.vue?vue&type=script&lang=js"
export * from "./CreatePersonalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6872a",
  null
  
)

export default component.exports